import { createAsyncAction } from "../utils/actionCreators";

export const types = {
  OBTER_RELATORIO: "@@dashboard/OBTER_RELATORIO",
};

export const actions = {
  obterRelatorio: createAsyncAction(types.OBTER_RELATORIO),
};
